import { http } from '@/core/api';

export const getCommentHistory = (studentSieId, academicYearId) =>
  http.get(`api/comment/${studentSieId}/${academicYearId}`);

export const saveComment = (payload) => http.post('api/comment', payload);
